import { createApp } from 'vue';
import App from './App.vue';
import { setupRouter } from './router/index';
import { setupStore } from '@/store';

import ElementPlus from 'element-plus';
import Vant from 'vant';
import ViewUIPlus from 'view-ui-plus';

import 'vant/lib/index.css';
import 'element-plus/dist/index.css';
import 'view-ui-plus/dist/styles/viewuiplus.css';

/* Elemetn Icon 组件 */
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import '@/styles/index.scss';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

/* 国际化 */
import { setupI18n } from './config/plugins/in18setup';

const setupAll = async () => {
	const app = createApp(App);

	for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
		app.component(key, component);
	}

	await setupI18n(app);
	setupStore(app);

	app.use(Vant);
	app.use(ViewUIPlus);
	app.use(ElementPlus, { locale: zhCn });

	setupRouter(app);
  
	app.mount('#app');
};

setupAll();
